<div class='InboxManagement container'>
  <div class='InboxManagement__header'>
    <h4 class='InboxManagement__title'>Configure Inbox Management</h4>
  </div>
  <div
    *ngIf='componentReady'
    [formGroup]='formGroup'
    class='InboxManagement__body'>
    <mat-tab-group #tabGroup mat-align-tabs='center'>
      <mat-tab label='Inbox cleaning tool'>
        <div class='row mb-5'>
          <mat-checkbox
            (change)='toggleCleaningPanel()'
            [checked]='enableInboxCleaningPanel'
          >Enable
          </mat-checkbox
          >
        </div>
        <div class='row'>
          <div class='col col-6'>
            <p class='InboxManagement__body__label'>
              Days after (number of days to wait before executing the
              scheduled action)
            </p>
          </div>
          <div class='col col-6'>
            <mat-form-field>
              <input
                formControlName='inbox_delay'
                matInput
                placeholder='Days after'
                type='number' />
            </mat-form-field>
          </div>
        </div>
        <div class='row'>
          <div class='col col-6'>
            <p class='InboxManagement__body__label no-margin'>
              Action to perform
            </p>
          </div>
          <div class='col col-6'>
            <mat-radio-group
              (change)='onInboxTypeChange($event)'
              formControlName='inbox_type'>
              <mat-radio-button
                class='InboxManagement__body__radio'
                value='cycle'
              >Cycle
              </mat-radio-button
              >
              <mat-radio-button
                class='InboxManagement__body__radio'
                value='campaign'
              >Campaign
              </mat-radio-button
              >
            </mat-radio-group>
          </div>
        </div>
        <div *ngIf='showInboxCapaignConfig'>
          <div class='row'>
            <div class='col col-6'>
              <p class='InboxManagement__body__label'>
                Move contact to selected campaign
              </p>
            </div>
            <div class='col col-6'>
              <app-select
                (selection)='onCampaignSelection($event)'
                [items]='getCampaignsSelectItems()'
                formControlName='inbox_campaign'
                label='Campaign'></app-select>
            </div>
          </div>
          <div *ngIf='inboxSelectedCampaignId' class='row'>
            <div class='col col-6'>
              <p class='InboxManagement__body__label'>
                Move contact to selected contact group
              </p>
            </div>
            <div class='col col-6'>
              <app-select
                [items]='getContactGroupsSelectItems()'
                formControlName='inbox_group'
                label='Contact group'></app-select>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label='Meeting, Order, Quote moving tool'>
        <div class='row mb-5'>
          <mat-checkbox
            (change)='toggleMeetingPanel()'
            [checked]='enableMeetingPanel'
          >Enable
          </mat-checkbox
          >
        </div>
        <div class='row'>
          <div class='col col-6'>
            <p class='InboxManagement__body__label'>
              Days after (number of days to wait before executing the
              scheduled action)
            </p>
          </div>
          <div class='col col-6'>
            <mat-form-field>
              <input
                formControlName='meeting_delay'
                matInput
                placeholder='Days after'
                type='number' />
            </mat-form-field>
          </div>
        </div>
        <div class='row'>
          <div class='col col-6'>
            <p class='InboxManagement__body__label'>
              Move opportunity to selected campaign
            </p>
          </div>
          <div class='col col-6'>
            <app-select
              (selection)='onCampaignSelection($event, true)'
              [items]='getCampaignsSelectItems()'
              formControlName='meeting_campaign'
              label='Campaign'></app-select>
          </div>
        </div>
        <div *ngIf='meetingSelectedCampaignId' class='row'>
          <div class='col col-6'>
            <p class='InboxManagement__body__label'>
              Move opportunity to selected contact group
            </p>
          </div>
          <div class='col col-6'>
            <app-select
              [items]='getContactGroupsSelectItems(true)'
              formControlName='meeting_group'
              label='Contact group'></app-select>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class='InboxManagement__footer'>
    <app-button
      *ngIf='turnOffButtonProperties'
      [Click]='turnOffButtonProperties.onClick'
      [color]='turnOffButtonProperties.color'
      [size]='turnOffButtonProperties.size'
      [text]='turnOffButtonProperties.text'></app-button>
    <app-button
      [Click]='turnOnButtonProperties.onClick'
      [color]='turnOnButtonProperties.color'
      [size]='turnOnButtonProperties.size'
      [text]='turnOnButtonProperties.text'></app-button>
  </div>
</div>
